import React, { useState } from 'react';
import { Button, Modal, Select, Avatar, Typography, message } from 'antd';
import { UserOutlined } from '@ant-design/icons';
import { api } from "@redux/api";
import { useSelector } from 'react-redux';

const { Option } = Select;
const { Text } = Typography;

// 封装一个通用的 AssignButton 组件
const AssignButton = ({ taskId, facilityId, onAssignSuccess }) => {
    const [modalVisible, setModalVisible] = useState(false);
    const [usersList, setUsersList] = useState([]);
    const [usersLoading, setUsersLoading] = useState(false);
    const [selectedUserId, setSelectedUserId] = useState(null);
    const [isAssigning, setIsAssigning] = useState(false);
    const ownerId = useSelector(state => state.Auth.userId);
    
    const loadUsers = async () => {
        try {
            setUsersLoading(true);
            const response = await api.filterAssignedUsers(facilityId);
            if (response && response.data && response.data.results) {
                setUsersList(response.data.results);
            }
        } catch (error) {
            console.error('Error loading users:', error);
            message.error('Failed to load users list');
        } finally {
            setUsersLoading(false);
        }
    };

    const showModal = () => {
        loadUsers();
        setModalVisible(true);
    };

    const handleCancel = () => {
        setModalVisible(false);
        setSelectedUserId(null);
    };

    const handleUserChange = (value) => {
        setSelectedUserId(value);
    };

    const handleAssign = async () => {
        if (!selectedUserId) {
            message.warning('Please select a user to assign the task');
            return;
        }

        try {
            setIsAssigning(true);
            await api.assignEUITask(taskId, selectedUserId, ownerId);
            message.success('Task assigned successfully');
            setModalVisible(false);
            setSelectedUserId(null);

            // 调用成功回调
            if (onAssignSuccess && typeof onAssignSuccess === 'function') {
                onAssignSuccess();
            }
        } catch (error) {
            console.error('Error assigning task:', error);
            message.error('Failed to assign task');
        } finally {
            setIsAssigning(false);
        }
    };

    return (
        <>
            <a onClick={showModal} style={{ cursor: 'pointer' }}>
                Assign
            </a>
            <Modal
                title="Assign Task"
                open={modalVisible}
                onOk={handleAssign}
                onCancel={handleCancel}
                confirmLoading={isAssigning}
            >
                <div style={{ marginBottom: 16 }}>
                    <p>Select a user to assign the task:</p>
                    <Select
                        showSearch
                        style={{ width: '100%' }}
                        placeholder="Select a user"
                        optionFilterProp="children"
                        onChange={handleUserChange}
                        value={selectedUserId}
                        loading={usersLoading}
                        filterOption={(input, option) =>{
                            return option.name.toLowerCase().indexOf(input.toLowerCase()) >= 0;
                            }
                        }
                    >
                        {usersList.map(user => (
                            <Option key={user.id} value={user.id} name={user.username}>
                                <div style={{ display: 'flex', alignItems: 'center' }}>
                                    <Avatar
                                        size="small"
                                        src={user.image}
                                        icon={<UserOutlined />}
                                        style={{ marginRight: 8 }}
                                    />
                                    <span>{user.username}</span>
                                    <Text type="secondary" style={{ marginLeft: 8 }}>
                                        ({user.email})
                                    </Text>
                                </div>
                            </Option>
                        ))}
                    </Select>
                </div>
            </Modal>
        </>
    );
};

export default AssignButton;